import { Resource, Layout, Admin } from "react-admin";
import { MyMenu } from "./DashboardMenu";
import { Dashboard } from "./Dashboard";
import { ClientList } from "./client/ClientList";
import { AddressList } from "./address/AddressList";
import { ConstructionSiteList } from "./construction_site/ConstructionSiteList";
import { JobList } from "./job/JobList";
import { PersonList } from "./person/PersonList";
import { PersonCreate } from "./person/PersonCreate";
import { ClientCreate } from "./client/ClientCreate";
import { ConstructionSiteCreate } from "./construction_site/ConstructionSiteCreate";
import { JobCreate } from "./job/JobCreate";
import { useDI } from "@infra/di/useDI";
import { CustomRoutes } from "react-admin";
import { Route } from "react-router-dom";
import { JobTrackMapPage } from "./job/JobTrackMapPage";
import type { I18nProvider } from "react-admin";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/de";
import { JobReportPage } from "./job/JobReportPage";
import { JobDetailsPage } from "./job/JobDetailsPage";
import { ClientEdit } from "./client/ClientEdit";
import { AddressEdit } from "./address/AddressEdit";
import { ConstructionSiteEdit } from "./construction_site/ConstructionSiteEdit";
import { AddressShow } from "./address/AddressShow";
import { ClientShow } from "./client/ClientShow";
import { ConstructionSiteShow } from "./construction_site/ConstructionSiteShow";
import { JobEdit } from "./job/JobEdit";
import { PersonShow } from "./person/PersonShow";
import { PersonEdit } from "./person/PersonEdit";
import BillingPage from "../account/BillingPage";
import SeatsPage from "../account/SeatsPage";
import { logamiTheme } from "../layout/LogamiTheme";

function MyLayout(props: any) {
  return (
    <Layout
      {...props}
      menu={MyMenu}
    />
  );
}

export default function AdminShell({
  i18nProvider,
}: {
  i18nProvider: I18nProvider;
}) {
  const { dataProvider } = useDI();

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
      <Admin
        dataProvider={dataProvider}
        i18nProvider={i18nProvider}
        layout={MyLayout}
        dashboard={Dashboard}
        basename="/dashboard"
        theme={logamiTheme}
        darkTheme={null}
      >
        <CustomRoutes>
          <Route path="/jobs/:id/map" element={<JobTrackMapPage />} />
        </CustomRoutes>
        <CustomRoutes>
          <Route path="/jobs/:id/report" element={<JobReportPage />} />
        </CustomRoutes>
        <CustomRoutes>
          <Route path="/settings/account/billing" element={<BillingPage />} />
        </CustomRoutes>
        <CustomRoutes>
          <Route path="/settings/account/seats" element={<SeatsPage />} />
        </CustomRoutes>

        <Resource
          name="clients"
          options={{ label: "Kunden" }}
          list={ClientList}
          create={ClientCreate}
          edit={ClientEdit}
          show={ClientShow}
        />
        <Resource
          name="constructionSites"
          options={{ label: "Einsatzorte" }}
          list={ConstructionSiteList}
          create={ConstructionSiteCreate}
          edit={ConstructionSiteEdit}
          show={ConstructionSiteShow}
        />
        <Resource
          name="jobs"
          options={{ label: "Aufträge" }}
          list={JobList}
          create={JobCreate}
          show={JobDetailsPage}
          edit={JobEdit}
        />
        <Resource
          name="persons"
          options={{ label: "Mitarbeiter" }}
          list={PersonList}
          create={PersonCreate}
          show={PersonShow}
          edit={PersonEdit}
        />
        <Resource
          name="addresses"
          options={{ label: "Adressen" }}
          list={AddressList}
          edit={AddressEdit}
          show={AddressShow}
        />
        <Resource name="assignees" />
      </Admin>
    </LocalizationProvider>
  );
}
